import { useQueries } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { selectDescription } from "../components/store/slices/ssrDescriptionSlice";
import { SWITCH_SLICES } from "../components/store/slices/switchSlices";
import { systemOf } from "../constants/systems";
import { useSwitchState } from "./useSwitchState";
import { getSSRsForDeviceService } from "../services";
import { buildSpecsFromHeaters } from "../helpers/buildSpecsFromHeaters";

export const getSSRFetchTargets = (switchStatus, { faultedOnly = true } = {}) =>
  Object.entries(switchStatus).flatMap(([location, zone]) =>
    Object.entries(zone)
      .filter(([, machine]) => !faultedOnly || machine.ssrFault?.includes(1))
      .map(([machineKey, machine]) => ({ location, machineKey, machine }))
  );

export const useGetAllSSRsQueries = (switchStatus, swtName, options) => {
  const dispatch = useDispatch();
  const { elementsOptions } = useSelector(selectDescription);
  const { flat: swtStatus } = useSwitchState(swtName);
  const { setSSRState } = SWITCH_SLICES[systemOf(swtName).key];

  const getSSRsQueries = useQueries(
    getSSRFetchTargets(switchStatus, options)
      .map(({ location, machineKey: machine, machine: machineData }) => ({
            queryKey: [machineData.deviceMac, '-ssrsData'],
            queryFn: () => getSSRsForDeviceService(machineData.deviceMac),
            onSuccess: (data) => {
              if (data) {
                const result = data.map((item) => {
                  const specs = buildSpecsFromHeaters(item.Heaters, elementsOptions);
                  return {
                    ...item,
                    select: `tc-${swtStatus[location]?.[machine]?.heaterThermocoupleMap?.[item.No]}`,
                    buttonStatus: item?.fault === true || item?.Load_exceeded === true ? 'flt' :
                      item?.active === true ? 'on' : 'off',
                    specs: specs.length !== 0 ? specs : [{}],
                    switchName: `${item.name} ${item.size}`,
                  };
                });
                const ssrStateData = {
                  location,
                  machine,
                  data: result,
                }
                dispatch(setSSRState(ssrStateData));


              }
            },
            onError: (error) => {
              console.error('get ssrs fail:', error.message);
            },
          }))
  );

  return getSSRsQueries;
};